import { render, staticRenderFns } from "./CreditNoteDataTable.vue?vue&type=template&id=505d49ec"
import script from "./CreditNoteDataTable.vue?vue&type=script&lang=js"
export * from "./CreditNoteDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports